import { put, select } from 'redux-saga/effects';
import { putEntities } from '../../redux/entities/actions';
import { getGallectionById } from '../selectors';
import type { Action } from 'redux-actions';
import type { ChangeGallectionNamePayload } from '../actions';
import type { PapiGallection } from '@wix/da-papi-types';
import { normalizeGallection } from '../../redux/normalizr/helpers';

function* setGallectionName(action: Action<ChangeGallectionNamePayload>) {
  const { folderId, name } = action.payload;
  const gallection: ReturnType<typeof getGallectionById> = yield select(
    getGallectionById,
    folderId
  );
  if (!gallection) {
    return;
  }

  const updatedGallection: PapiGallection = {
    ...gallection,
    name,
  };

  const entities = normalizeGallection(updatedGallection);
  yield put(putEntities({ entities }));
}

export default setGallectionName;
